import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';

const Root = styled(Horizontal)`
  background-color: var(--c-red-800);
  border-radius: var(--unit);
  padding: var(--half-unit) var(--unit);
`;

export const FewLeft = () => (
  <Root>
    <LabelS as="span" color="var(--c-white)">
      <FormattedMessage
        id="ClubShop.Item.Label.FewLeft"
        defaultMessage="Few left"
      />
    </LabelS>
  </Root>
);
